<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.feeding_care.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create feeding care -->
        <b-modal size="md" id="create" hide-footer>
          <template v-slot:modal-title>Novo cuidado alimentício</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="A partir" />
                    <input type="time" v-model="init" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Posição" />
                    <input
                      type="number"
                      v-model="position"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create feeding care -->
        <v-card>
          <v-card-title>
            Cuidados alimentícios
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="feeding_cares"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.init`]="{ item }">{{
              String(item.init)
            }}</template>
            <template v-slot:[`item.end`]="{ item }">{{
              String(item.end)
            }}</template>
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar cuidado alimentício -->
              <b-modal size="md" :id="String(item.id)" hide-footer>
                <template v-slot:modal-title>
                  Editar cuidado alimentício
                </template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay :show="loadingFeedingCareUpdate" opacity="0.99">
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.feeding_care.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-6">
                            <LabelRequiredField label="A partir" />
                            <input
                              :disabled="!permissions.feeding_care.edit"
                              type="time"
                              v-model="init"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-6">
                            <LabelRequiredField label="Posição" />
                            <input
                              :disabled="!permissions.feeding_care.edit"
                              type="number"
                              v-model="position"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.feeding_care.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              v-if="permissions.feeding_care.remove"
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) => deleteFeedingCare(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar o banco? <hr /> Só pode apagar caso não exista vinculo do banco com fornecedor!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar acesso -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import { formatDate } from "../functions/format";
import toast from "../components/ToastNotification";
import api from "../services/api";
import { adminData } from "../lib/functions";

export default {
  name: "FeedingCare",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "ID", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { text: "A partir", value: "init" },
        { text: "Posição", value: "position" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      name: "",
      init: "",
      position: "",
      feeding_cares: [],
      loadingUpdate: false,
      loadingFeedingCareUpdate: false,
      loadingCreate: false,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalFeedingCare(item.id);
      this.$bvModal.show(String(item.id));
    },
    retrieve() {
      this.permissions = adminData().permissions;

      this.getFeedingCares();
    },
    async getFeedingCares(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/feeding/care/paginate", {
          params: { page },
        });

        const { feeding_cares } = response.data;

        this.feeding_cares = feeding_cares;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      event.preventDefault();
      this.loadingCreate = true;

      try {
        const { name, init, position } = this;

        let params = {
          name,
          init,
          position,
        };

        const response = await api.post("/admin/feeding/care/create", params);

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.getFeedingCares();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.init = "";
      this.position = "";
      this.$bvModal.show("create");
    },
    async handleModalFeedingCare(id) {
      try {
        this.loadingFeedingUpdate = true;

        this.id = id;

        const response = await api.get("/admin/feeding/care/get", {
          params: { id },
        });

        const { feeding_care } = response.data;

        this.id = feeding_care.id;
        this.name = feeding_care.name;
        this.init = feeding_care.init;
        this.position = feeding_care.position;
        this.loadingFeedingCareUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name, init, position } = this;

        let params = {
          id,
          name,
          init,
          position,
        };

        const response = await api.put("/admin/feeding/care/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getFeedingCares();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteFeedingCare(dialog, feeding_care) {
      try {
        const { id } = feeding_care;

        let data = { id };

        const response = await api.delete("/admin/feeding/care/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getFeedingCares();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>